import SmallHeadingComponent from "../SmallHeadingComponent"
import Card from "../Card"
import showcase from "../../resources/pokal_connect_app/pokal_connect_app.png"
import PatientIcon from "../PatientIcon"
import Link from "../Link"

function PokalConnectApp() {
    return (
        <Card width={"100%"} fill={true}>
            <div className={"flex space-x-4"}>
                <div
                    style={{ marginTop: -50 }}
                    className={"flex-1 max-w-[250px]"}>
                    <img
                        className={"rounded-3xl border-2 shadow -rotate-2"}
                        src={showcase}
                    />
                </div>
                <div className={"flex-1 flex flex-col"}>
                    <SmallHeadingComponent>
                        DOOR Studie Connect App
                    </SmallHeadingComponent>
                    <div className={"mt-4"}>
                        Unterstützt Patient:innen beim Verwalten und Teilen
                        ihrer Daten.
                    </div>
                    <Link download={"door_studie_connect.apk"}>Android App</Link>
                    <div className={"mt-auto ml-auto"}>
                        <PatientIcon />
                    </div>
                </div>
            </div>
        </Card>
    )
}

export default PokalConnectApp
